import request, {METHODS} from '@/api'
import UrlConfig from '@/api/UrlConfigs'
import {get} from 'lodash-es'

/**
 * 承包商列表
 */
export const getVendorInfoList = (current, pageSize, params) => {
  return request(`${UrlConfig.plusPmWeb.VendorInfoPage}?current=${current}&pageSize=${pageSize}`, {
    method: METHODS.POST,
    data: params,
  }).then((resp: any) => {
    const records = get(resp, 'list', [])
    const total = get(resp, 'count', 0)
    return { records, total }
  })
}
/**
 * 承包商-新增
 */
export const vendorInfoAdd = data => {
  return request(UrlConfig.plusPmWeb.VendorInfoAddOrUpdate, {
    method: METHODS.POST,
    data: data,
  }).then((resp: any) => {
    return resp
  })
}
/**
 * 承包商-编辑
 */
export const vendorInfoUpdateById = data => {
  return request(UrlConfig.plusPmWeb.VendorInfoAddOrUpdate, {
    method: METHODS.POST,
    data: data,
  }).then((resp: any) => {
      return resp
  })
}
/**
 * 承包商-认证
 */
export const vendorInfoAttestationInfo = data => {
    return request(UrlConfig.plusPmWeb.VendorInfoAttestationInfo, {
        method: METHODS.POST,
        data: data,
  }).then((resp: any) => {
    return resp
  })
}
/**
 * 承包商-获取详情
 */
 export const getVendorInfo= (data) => {
  return request(UrlConfig.plusPmWeb.FindVendorInfoOne, {
    method: METHODS.POST,
    data: data
  }).then((resp: any) => {
    return resp
  })
}


/**
 * 工种-保存
 */
 export const workTypePageAdd = data => {
  return request(UrlConfig.plusPmWeb.WorkTypePageAdd, {
    method: METHODS.POST,
    data: data,
  }).then((resp: any) => {
    return resp
  })
}

